// EventsLedger.tsx — collapsible table of every engine event. Negative Kontostand
// (Verrechnungskonto) rows are highlighted (D-004: correct, expected behaviour).
import type { EngineEvent } from '@etf-cockpit/engine';
import { describeEvent } from '../lib/events.js';
import { formatCentsPlain, formatDateDe } from '../lib/format.js';

export interface EventsLedgerProps {
  events: EngineEvent[];
}

export function EventsLedger({ events }: EventsLedgerProps) {
  if (events.length === 0) {
    return <div class="empty-state">Keine Ereignisse.</div>;
  }
  return (
    <details class="events-details">
      <summary>Ereignisse ({events.length})</summary>
      <div class="events-table-wrap">
        <table class="events-table">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Typ</th>
              <th>Betrag</th>
              <th>KESt</th>
              <th>Kontostand danach</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event, i) => {
              const row = describeEvent(event);
              const negative = row.settlementAfterCents < 0;
              return (
                <tr key={i} class={negative ? 'negative' : undefined}>
                  <td>{formatDateDe(row.date)}</td>
                  <td>{row.typeLabel}</td>
                  <td>{formatCentsPlain(row.amountCents)}</td>
                  <td>{row.kestCents === null ? '—' : formatCentsPlain(row.kestCents)}</td>
                  <td>{formatCentsPlain(row.settlementAfterCents)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </details>
  );
}
